const CHUNK_SIZE = 524288;

export { CHUNK_SIZE };
